import { DropZoneType } from "./DropZoneUtil";

export default class DropZoneSprite extends Phaser.GameObjects.Sprite implements DropZoneType {
    dropZoneKeys: string[] = [];
    constructor(scene: Phaser.Scene, dropZoneKeys: string | string[], x: number, y: number, texture: string, frame?: string | integer) {
        super(scene, x, y, texture, frame);
        this.scene.add.existing(this);
        this.dropZoneKeys = Array.isArray(dropZoneKeys) ? dropZoneKeys as string[] : [dropZoneKeys as string];
    }
}



// WEBPACK FOOTER //
// ./src/games/shared/dropzone/DropZoneSprite.ts